// extracted by mini-css-extract-plugin
module.exports = {"icon":"Loading_icon__mIswD"};